module.exports = __webpack_public_path__ + "static/media/Frame.c0cd0c12.png";